<template>
    <div class="form-group  mb-0">
        <button type="button" class="btn btn-danger" @click="deleteBtn">
            {{title}}
        </button>

        <b-modal hide-footer hide-header ref="confirmModal"
                  >
            <div style="margin: -16px">
            <div class="card">
                <div class=" p-2 bg-light">
                    <span>تایید حذف</span>
                    <button type="button" class="close" data-dismiss="modal">
                        <span>&times;</span>
                    </button>
                </div>
                <div class='p-3'>

                    <p>آیا مطمعن هستید؟ اطلاعات حذف خواهد شد</p>
                    <button type="button" class="btn btn-danger delete-button" @click="deleteItem">حذف</button>
                </div>

            </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import mixinField from '../mixins/mixinField';

    export default {
        mixins: [mixinField],

        name: "ButtonDelete",
        props: ['title', 'link', 'id'],
        methods: {
            deleteBtn: function () {
                this.$refs.confirmModal.show();
            },
            deleteItem: function () {


                this.axios.delete(this.link + "/" + this.id)
                    .then(({data}) => {
                        this.$refs.confirmModal.hide();
                        this.$emit('deleted')
                    });


            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ButtonDelete.vue